// Structured Data helpers for different page types

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Algoarts",
  "alternateName": "Algoarts Technologies Private Limited",
  "url": "https://algoarts.tech",
  "logo": "https://algoarts.tech/logo192.png",
  "description": "Leading software development company providing IT consulting, custom software development, web development, and digital transformation services.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "LK",
    "addressLocality": "Sri Lanka"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+94-773-112-006",
    "contactType": "Customer Service",
    "areaServed": "Worldwide",
    "availableLanguage": ["English"]
  },
  "sameAs": [
    "https://www.linkedin.com/company/algoarts",
    "https://twitter.com/algoarts",
    "https://www.facebook.com/algoarts"
  ]
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getServiceSchema = (serviceName, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "provider": {
    "@type": "Organization",
    "name": "Algoarts"
  },
  "description": description,
  "areaServed": "Worldwide"
});

export const getArticleSchema = (article) => {
  const firstImage = article.content?.find(item => item.type === 'image')?.content;
  const firstParagraph = article.content?.find(item => item.type === 'paragraph')?.content;
  
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.heading,
    "description": firstParagraph || article.heading,
    "image": firstImage || "https://algoarts.tech/logo192.png",
    "author": {
      "@type": "Person",
      "name": article.author || "Algoarts Team",
      "jobTitle": article.designation || "Software Engineer"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Algoarts",
      "logo": {
        "@type": "ImageObject",
        "url": "https://algoarts.tech/logo192.png"
      }
    },
    "datePublished": article.createdAt,
    "dateModified": article.updatedAt || article.createdAt,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://algoarts.tech/academy/blog/${article._id}`
    },
    "articleSection": article.tag || "Technology"
  };
};

export const getWebPageSchema = (pageName, description, url) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": pageName,
  "description": description,
  "url": url,
  "inLanguage": "en-US",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Algoarts",
    "url": "https://algoarts.tech"
  }
});

